<template>
  <div>
    <v-app-bar app clipped-left flat :style="appBarStyle">
      <v-app-bar-nav-icon
        @click="showMenuDrawer = !showMenuDrawer"
      ></v-app-bar-nav-icon>

      <v-toolbar-title color="primary">{{ companyName }}</v-toolbar-title>
      <v-spacer />

      <v-tooltip v-if="trollyItems" class="hidden-md-and-down" bottom>
        <template v-slot:activator="{ on }">
          <span class="mr-2" v-if="retrieveShowPrices == true" v-on="on"
            >£{{ trollyTotal }}</span
          >
        </template>
        <span>Basket Value</span>
      </v-tooltip>

      <v-tooltip bottom v-if="!retrieveGuest">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            :color="
              retrieveTrollyRequiresAttentionFlag
                ? 'error darken-1'
                : 'primary darken-1'
            "
            icon
            @click="dialog = false"
            :to="{ name: 'OrdersBasket' }"
          >
            <v-badge
              v-if="trollyItems"
              color="orange darken-2"
              overlap
              :content="trollyItems"
            >
              <v-icon>shopping_cart</v-icon>
            </v-badge>
            <v-icon v-else>shopping_cart</v-icon>
          </v-btn>
        </template>
        <span>View Basket</span>
      </v-tooltip>

      <v-tooltip
        v-if="
          $store.getters.retrieveIsCashCustomer ||
          ($store.getters.retrieveIsCncCustomer && !retrieveGuest)
        "
        bottom
        class="mr-2 hidden-md-and-down"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            color="primary darken-1"
            icon
            class="hidden-md-and-down"
          >
            <span v-if="$store.getters.retrieveIsCashCustomer">D</span>
            <span v-else>C</span>
          </v-btn>
        </template>
        <span v-if="$store.getters.retrieveIsCashCustomer">Delivery Order</span>
        <span v-else>Collection Order</span>
      </v-tooltip>
      <v-btn
        v-if="retrieveGuest"
        color="primary"
        outlined
        dark
        @click.stop="goToSignIn"
        class="hidden-md-and-down ml-2"
        >Sign In</v-btn
      >
      <v-btn
        v-if="retrieveGuest"
        color="primary"
        outlined
        dark
        :to="{ name: 'Registration' }"
        class="hidden-md-and-down ml-2"
        >Register</v-btn
      >
      <v-dialog
        v-model="dialog"
        persistent
        max-width="290"
        v-if="!retrieveGuest"
        @keydown.esc="dialog = false"
        eager
        @keydown.enter="signOut()"
      >
        <template v-slot:activator="{ on }">
          <div>
            <v-btn
              color="primary"
              outlined
              block
              v-on="on"
              class="hidden-md-and-down ml-2 white--text"
              >Sign Out</v-btn
            >
          </div>
        </template>

        <template v-slot:prepend v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
        </template>
        <v-card>
          <v-toolbar color="background" flat dense>
            <v-toolbar-title>Sign Out</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-subtitle color="background" class="mt-4"
            >You will need to sign in again to use the site.</v-card-subtitle
          >
          <v-card-actions class="dialogActions">
            <v-btn text @click="dialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              outlined
              color="blue darken-2"
              @click="(dialog = false), signOut()"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-app-bar>
    <v-navigation-drawer
      clipped
      app
      floating
      v-model="showMenuDrawer"
      :style="naviationStyle"
      class="borderRight"
    >
      <v-dialog
        v-model="dialog"
        persistent
        :retain-focus="false"
        max-width="290"
        @keydown.esc="dialog = false"
        eager
        @keydown.enter="signOut()"
      >
        <template v-slot:activator="{ on }">
          <div class="hidden-lg-and-up pa-2">
            <v-btn color="primary" dark block v-on="on">Sign Out</v-btn>
          </div>
        </template>

        <template v-slot:prepend v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
        </template>
        <v-card>
          <v-toolbar color="background" flat dense>
            <v-toolbar-title>Sign Out</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-subtitle class="mt-4"
            >You will need to sign in again to use the site.</v-card-subtitle
          >
          <v-card-actions class="dialogActions">
            <v-btn text @click="dialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-2"
              outlined
              @click="(dialog = false), signOut()"
              >Yes</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-list nav dense v-if="retrieveGuest">
        <v-list-item-group exact-active-class="primary--text text--accent-4">
          <v-list-item
            @click.stop="goToSignIn"
            exact
            exact-active-class="primary--text text--accent-4"
          >
            <v-icon :color="menu_icon" class="mr-2">account_circle</v-icon>
            <v-list-item-title>Sign In</v-list-item-title>
          </v-list-item>
          <v-list-item
            :to="{ name: 'Registration' }"
            exact
            exact-active-class="primary--text text--accent-4"
          >
            <v-icon :color="menu_icon" class="mr-2">person_add</v-icon>
            <v-list-item-title>Register</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click.stop="goToWelcome"
            exact
            exact-active-class="primary--text text--accent-4"
          >
            <v-icon :color="menu_icon" class="mr-2">house</v-icon>
            <v-list-item-title>Welcome Page</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <v-list nav dense v-else>
        <v-list-item-group exact-active-class="primary--text text--accent-4">
          <v-list-item
            :to="{ name: 'Home' }"
            exact
            exact-active-class="primary--text text--accent-4"
            @click="checkMenuCollapse()"
          >
            <v-icon :color="menu_icon" class="mr-2">mdi-home</v-icon>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item>
        </v-list-item-group>

        <div
          v-for="(mainItem, index) in mainItems"
          :key="index"
          style="margin-top: 16px"
        >
          <v-list-item-group
            active-class="primary--text text--accent-4"
            v-if="checkShow(mainItem)"
            :color="mainItem.color"
          >
            <v-subheader>{{ mainItem.title }}</v-subheader>
            <div v-for="(item, index) in mainItem.subItems" :key="index">
              <div v-if="checkShow(item)">
                <v-list-item
                  :to="item.link"
                  exact-active-class
                  exact
                  inset
                  :color="menu_color"
                  @click="checkMenuCollapse()"
                >
                  <v-icon :color="menu_icon" left>{{ item.icon }}</v-icon>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
              </div>
            </div>
          </v-list-item-group>
        </div>

        <v-list-item-group style="margin-top: 16px">
          <v-subheader>Others</v-subheader>
          <v-list-item
            :to="{ name: 'FAQ' }"
            :color="menu_color"
            active-class="primary--text text--accent-4"
            @click="checkMenuCollapse()"
          >
            <v-icon left :color="menu_icon"
              >mdi-comment-question-outline</v-icon
            >
            <v-list-item-title>FAQ</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-if="!$store.getters.retrieveAnon"
            :to="{ name: 'UserAccount' }"
            :color="menu_color"
            active-class="primary--text text--accent-4"
            @click="checkMenuCollapse()"
          >
            <v-icon left :color="menu_icon">mdi-account-circle-outline</v-icon>
            <v-list-item-title>Account</v-list-item-title>
          </v-list-item>

          <v-list-item
            :to="{ name: 'UserSettings' }"
            :color="menu_color"
            active-class="primary--text text--accent-4"
            @click="checkMenuCollapse()"
          >
            <v-icon left :color="menu_icon">settings</v-icon>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "MainMenu",
  components: {},
  data() {
    return {
      companyName: process.env.VUE_APP_COMPANY_NAME,
      showMenuDrawer: false,
      dialog: false,
      isMobile: !this.$vuetify.breakpoint.lgAndUp,
    };
  },
  beforeMount() {
    this.checkDrawer();
  },

  mounted() {
    window.addEventListener("resize", () => {
      this.isMobile = !this.$vuetify.breakpoint.lgAndUp;
    });
  },

  methods: {
    ...mapActions(["clearUser", "clearCustomer", "clearFAQ", "clearOrders"]),

    ...mapActions("orderSearch", ["clearGroups"]),

    checkDrawer() {
      if (this.isMobile) {
        this.showMenuDrawer = false;
      } else {
        this.showMenuDrawer = this.$store.getters.retrieveShowMenuDrawer;
      }
    },

    checkMenuCollapse() {
      if (!this.isMobile) {
        if (!this.$store.getters.retrieveShowMenuDrawer) {
          this.showMenuDrawer = false;
        }
      }
    },

    checkShow(item) {
      let showItem = false;

      switch (parseInt(item.show)) {
        case 0:
          showItem = false;
          break;

        case 1:
          showItem = true;
          break;

        case 2:
          console.log("-- 2");

          if (
            this.$store.getters.retrieveIsCashCustomer ||
            this.$store.getters.retrieveIsCncCustomer
          ) {
            showItem = true;
          } else {
            showItem = false;
          }
          break;

        case 3:
          if (
            this.$store.getters.retrieveIsCashCustomer ||
            this.$store.getters.retrieveIsCncCustomer
          ) {
            showItem = false;
          } else {
            showItem = true;
          }
          break;

        case 4:
          if (
            this.$store.getters.retrieveAdmin.account_type == "A1" ||
            this.$store.getters.retrieveAdmin.account_type == "D1"
          ) {
            showItem = true;
          } else {
            showItem = false;
          }
          break;

        case 5:
          if (this.$store.getters.retrieveAdmin.account_type == "A1") {
            showItem = true;
          } else {
            showItem = false;
          }
          break;

        default:
          showItem = false;
          break;
      }

      return showItem;
    },

    signOut() {
      //Clear our user here once done re-direct us out
      // this.clearCustomer();
      // this.clearUser();
      // this.clearFAQ();
      // this.clearOrders();
      // this.clearGroups();

      this.dialog = false;
      if (process.env.VUE_APP_NO_WELCOME_PAGE == "true") {
        this.$router.push({ name: "SignIn" }).catch((er) => {
          console.log(er);
        });
      } else {
        this.$router.push({ name: "Welcome" }).catch((er) => {
          console.log(er);
        });
      }

      this.$store.dispatch("userSignoutAction");
      this.$store.dispatch("setGuestUser", false);
      this.$store.dispatch("setAnonUser", false);
    },
    goToSignIn() {
      this.signOut();
      this.$router.push({ name: "SignIn" }).catch((er) => {
        console.log(er);
      });
    },
    goToWelcome() {
      this.signOut();
      this.$router.push({ name: "Welcome" }).catch((er) => {
        console.log(er);
      });
    },
  },
  computed: {
    ...mapGetters([
      "retrieveGuest",
      "retrieveTrollyRequiresAttentionFlag",
      "retrieveShowPrices",
    ]),

    mainItems() {
      return this.$store.getters.retrieveMenuOptions;
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    menu_color() {
      return this.$vuetify.theme.themes[this.theme].menu_color;
    },

    menu_icon() {
      return this.$vuetify.theme.themes[this.theme].menu_icon;
    },

    appBarStyle() {
      const Style = {
        background: this.$vuetify.theme.themes[this.theme].background_alt,
        // "border-width": "0 0 thin",
        // "border-style": "solid",
        // "border-color": this.$vuetify.theme.themes[this.theme]
        //   .menu_border_color,

        "border-bottom": "1px solid var(--v-menu_border_color-base)",
      };
      return Style;
    },

    naviationStyle() {
      const Style = {
        "z-index": 5,
        background: this.$vuetify.theme.themes[this.theme].background,
      };
      return Style;
    },

    trolly() {
      return this.$store.getters.retrieveCurrentTrolly;
    },

    trollyItems() {
      if (this.trolly) {
        return this.$store.getters.retrieveCurrentTrolly.totalItems;
      } else {
        return false;
      }
    },

    trollyTotal() {
      if (this.trolly) {
        return parseFloat(
          this.$store.getters.retrieveCurrentTrolly.grand_total
        ).toFixed(2);
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
@import "~vuetify/src/styles/styles.sass"

.v-list
  border-radius: 0
</style>
